
define('app/dashboard/purchase/purchaseApp',[
	'jquery',
	'underscore',
	'backbone',
	'known/knownUtil',
	'known/models/userModel',
	'known/collections/productCollection',
	'app/dashboard/purchase/views/purchaseView'
], function(
		$, 
		_, 
		Backbone,
		KnownUtil,
		UserModel,  
		ProductCollection,
		PurchaseView){
	var initialize = function(){
		var initialModels = KnownUtil.setupSideNav();
		var userModel = initialModels.userModel;
		var prodCollection = initialModels.prodCollection;
		
		var purchaseView = new PurchaseView({
			userModel: userModel, 
			model: prodCollection});
		purchaseView.render();
	};
	
	return {
		initialize: initialize
	};
});